import { render } from "./BackgroundImageOption.vue?vue&type=template&id=48f3dd7e"
import script from "./BackgroundImageOption.vue?vue&type=script&lang=ts"
export * from "./BackgroundImageOption.vue?vue&type=script&lang=ts"
script.render = render

export default script